import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/radix/dropdown-menu";
import { RelationshipToggle } from "@/components/relationship-toggle";
import { useAuth } from "@/hooks/use-auth";
import { LayoutDashboard, LogOut, Plus, Settings, User } from "lucide-react";
import Link from "next/link";
import { DropdownProps } from "./types";

export function SignInDropdown({ trigger, className }: DropdownProps) {
	const { user, logout } = useAuth();

	const firstGroup = Array.isArray(user?.groups) ? user.groups[0] : undefined;
	const currentRelationship = user?.relation || firstGroup?.relationship || "buyer";

	const handleLogout = async () => {
		await logout();
	};

	if (!user) {
		return null;
	}

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
			<DropdownMenuContent
				align="end"
				className={`unfocusable w-64 bg-white border border-gray-200 shadow-lg z-[9999] ${className || ""}`}
				sideOffset={5}
			>
				<div className="px-3 py-2 text-sm">
					<div className="font-medium text-gray-900">{user?.name || "Unknown User"}</div>
					<div className="text-gray-500 truncate">{user?.phones?.[0]?.number || "No phone"}</div>
				</div>
				<DropdownMenuSeparator />

				{/* Relationship Toggle */}
				<div className="px-3 py-2">
					<div className="text-xs font-medium text-gray-500 mb-2">Relationship</div>
					<RelationshipToggle />
				</div>
				<DropdownMenuSeparator />

				<DropdownMenuItem asChild>
					<Link href="/profile" className="flex items-center">
						<User className="w-4 h-4 mr-2" />
						Profile
					</Link>
				</DropdownMenuItem>
				<DropdownMenuItem asChild>
					<Link href="/dashboard" className="flex items-center">
						<LayoutDashboard className="w-4 h-4 mr-2" />
						Dashboard
					</Link>
				</DropdownMenuItem>
				<DropdownMenuItem asChild>
					<Link href="/sell" className="flex items-center">
						<Plus className="w-4 h-4 mr-2" />
						Add a property to sell
					</Link>
				</DropdownMenuItem>
				<DropdownMenuSeparator />
				{currentRelationship === "buyer" && (
					<DropdownMenuItem asChild>
						<Link href="/preference-summary" className="flex items-center">
							<Settings className="w-4 h-4 mr-2" />
							Preferences
						</Link>
					</DropdownMenuItem>
				)}
				<DropdownMenuSeparator />
				<DropdownMenuItem onSelect={handleLogout} className="text-red-600 focus:text-red-600">
					<LogOut className="w-4 h-4 mr-2" />
					Log Out
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
